import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=d183d8fc&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d183d8fc')) {
      api.createRecord('d183d8fc', component.options)
    } else {
      api.reload('d183d8fc', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=d183d8fc&", function () {
      api.rerender('d183d8fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2QnAeRhqHcRlA/JS/comp/FavElement.vue"
export default component.exports